<template>
  <div class="space">
    <div class="center">
      <div class="center-top">

        <div class="return" @click="repage"><img src="@/assets/images/return.png" alt="">返回上一步</div>
        <div class="step">
          <div :class="step == 0 ? 'item itemed' : 'item'">剧本创意</div>
          <div class="jt"><img v-show="step == 0" src="@/assets/images/jtl.png" alt=""><img v-show="step != 0"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 1 ? 'item itemed' : 'item'">剧情梗概</div>
          <div class="jt"><img v-show="step == 1" src="@/assets/images/jtl.png" alt=""><img v-show="step != 1"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 2 ? 'item itemed' : 'item'">分段脚本</div>
          <div class="jt"><img v-show="step == 2" src="@/assets/images/jtl.png" alt=""><img v-show="step != 2"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 3 ? 'item itemed' : 'item'">角色设计</div>
          <div class="jt"><img v-show="step == 3" src="@/assets/images/jtl.png" alt=""><img v-show="step != 3"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 4 ? 'item itemed' : 'item'">生成分镜</div>
        </div>
      </div>
      <div class="center-body">

        <div class="stepbox step2">
          <div class="loading" v-if="loading1">
            <div class="l1"><a-spin size="large" /></div>
            <div class="js">正在生成创意梗概...，约耗时45秒左右，请勿离开页面</div>
            <div class="con">
              <div class="item"><el-skeleton :rows="6" animated /></div>
              <div class="item"><el-skeleton :rows="6" animated /></div>
              <div class="item"><el-skeleton :rows="6" animated /></div>
              <div class="item"><el-skeleton :rows="6" animated /></div>
            </div>
          </div>
          <div class="loaded" v-else>
            <div class="con">
              <div class="item" v-for="(item, index) in generateLits" :key="index">
                <div class="it1">{{ item.title }}</div>
                <div class="it2">
                  <textarea class="custom-scrollbar" v-model="item.summary" name="" id=""></textarea>
                </div>
                <div class="it3">
                  <div v-for="(item2, index2) in item.tags" :key="index2">{{ item2 }}</div>
                </div>
                <div class="it4" @click="createjb(item)">生成</div>
              </div>
            </div>
            <div class="refresh">
              <div @click="init"><img src="@/assets/images/refresh.png" alt="">换一批</div>
            </div>
          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: '',
  data () {
    return {
      step: 1,
      id: 0,
      generateLits: [],
      record_id: 0,//剧本id
      loading1: true,
    }
  },
  async created () {
    this.id = this.$route.query.id

    // 是否是查看历史
    if (this.$route.query.record_id) {
      this.record_id = this.$route.query.record_id
      const res = await this.$http('api.getGenerateHis', { script_idea_id: this.record_id })
      this.resetdata(res.data)

    } else {
      this.init()
    }

  },
  mounted () {
    this.$bus.$emit('menu-active', false) // 关闭激活状态
  },
  methods: {
    async init () {
      this.loading1 = true
      let data = JSON.parse(sessionStorage.getItem('index2'))
      const res = await this.$http('api.getGenerate', data)
      // 添加历史
      const currentQuery = { ...this.$route.query };
      currentQuery.record_id = res.data.record_id; // 新增 record_id=5
      this.$router.replace({
        path: this.$route.path, // 保持当前路径不变
        query: currentQuery // 合并后的 query 参数
      });

      this.resetdata(res.data)
    },
    async resetdata (data) {
      data.ideas.forEach(item => {
        item.tags = item.tags.split(',')
      })
      this.record_id = data.record_id
      this.generateLits = data.ideas
      this.loading1 = false
      //   const res2 = await this.$http('api.getIdeas', { project_id: this.id })
      //   this.his = res2.data
      // },

    },
    // 换一批
    async refresh () {
      this.loading1 = true
      const res = await this.$http('api.refreshGenerate', { record_id: this.record_id })
      this.resetdata(res.data)
    },
    // 生成分段脚本
    async createjb (val) {
      if (val.has_segment) {
        this.$router.push(`/project2/project2_3?id=${this.id}&idea_id=${val.id}&random=${Math.random()}`)
        return
      }
      let str = ''
      val.tags.forEach((item, index) => {
        if (index !== val.tags.length - 1) {
          str += item + ','
        } else {
          str += item
        }
      })
      const data = {
        script_summary_id: val.id,
        title: val.title,
        summary: val.summary,
        tags: str
      }
      sessionStorage.setItem('index3', JSON.stringify(data))
      this.$router.push(`/project2/project2_3?id=${this.id}&idea_id=${val.id}&random=${Math.random()}`)

    },
    repage () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.space {
  width: 100%;
  height: 100%;
  display: flex;

  .history {
    width: 300px;
    height: 100%;
    background-color: #f1f1f1;
    padding: 20px;

    .his1 {
      font-size: 16px;
      color: #636262;
    }

    .his-body {
      margin-top: 20px;
      height: calc(100vh - 150px);
      width: 100%;
      overflow: auto;

      .item {
        width: 100%;
        font-size: 16px;
        margin-bottom: 24px;
        color: #595959;
        height: 20px;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
      }

      .item:hover {
        color: #3f81e4;
      }
    }
  }

  .center {
    flex: 1;
    // padding: 20px;
    height: calc(100vh - 80px);

    .center-top {
      margin-top: 20px;
      height: 44px;
      position: relative;

      .return,
      .next {
        position: absolute;
        width: 134px;
        text-align: center;
        height: 36px;
        line-height: 36px;
        top: 50%;
        transform: translateY(-50%);
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #DDDDDD;
        cursor: pointer;

        img {
          width: 20px;
          margin-right: 4px;
          transform: translateY(-2px);
        }
      }

      .return {
        left: 20px;
      }

      .next {
        right: 20px;
      }

      .step {
        margin: 0 auto;
        width: 620px;
        height: 44px;
        line-height: 44px;
        background: #FFFFFF;
        box-shadow: 2px 2px 12px 0px rgba(97, 92, 92, 0.2);
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #046DFA;
        display: flex;
        justify-content: center;

        .item {
          font-size: 18px;
          color: #595959;
        }

        .itemed {
          font-weight: bold;
          color: #046DFA;
        }

        .jt {
          margin: 0 16px;

          img {
            width: 16px;
          }
        }
      }
    }

    .center-body {
      margin: 0 auto;
      width: 100%;
      margin-top: 20px;
      height: calc(100vh - 180px);
      overflow: hidden;

      .stepbox {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;

      }

      .step2 {
        padding: 0 20px;

        .con {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          .item {
            padding: 20px;
            background: #F8F8F8;
            margin-top: 24px;
            width: 48%;
            height: 280px;
            border-radius: 12px 12px 12px 12px;
          }
        }

        .loading {
          .l1 {
            margin-top: 10px;
            width: 100%;
            text-align: center;
          }

          .js {
            font-size: 14px;
            color: #046DFA;
            margin-top: 12px;
            width: 100%;
            text-align: center;
          }

        }

        .loaded {
          .con {
            .item {
              border: 1px solid transparent;
              position: relative;

              .it1 {
                font-size: 18px;
                color: #262626;
              }

              .it2 {
                margin-top: 14px;
                width: 100%;

                height: 108px;

                textarea {
                  width: 100%;
                  height: 100%;
                  resize: none;
                  border-radius: 6px 6px 6px 6px;
                  border: 1px solid transparent;
                  padding: 10px;
                  background-color: transparent;
                }

                textarea:hover {
                  border: 1px solid #046DFA;
                }
              }

              .it3 {
                display: flex;
                margin-top: 40px;

                div {
                  margin-right: 6px;
                  padding: 4px 8px;
                  font-size: 13px;
                  color: #FFFFFF;
                  background: #595959;
                  border-radius: 30px 30px 30px 30px;
                }
              }

              .it4 {
                position: absolute;
                width: 60px;
                font-size: 14px;
                height: 30px;
                line-height: 30px;
                background: linear-gradient(90deg, #66AFFF 0%, #046CF3 100%);
                right: 20px;
                bottom: 10px;
                text-align: center;
                color: white;
                border-radius: 8px;
                cursor: pointer;
                display: none;
              }

              .it4:hover {
                background: linear-gradient(90deg, #84b5e9 0%, #4a8add 100%);
              }
            }

            .item:hover {
              border: 1px solid #046DFA;
            }

            .item:hover .it4 {
              display: block;
            }
          }

          .refresh {
            margin-top: 20px;
            display: flex;
            font-size: 16px;
            color: #595959;
            justify-content: right;
            cursor: pointer;

            img {
              width: 20px;
              margin-right: 4px;
              transform: translateY(-2px);
            }
          }
        }
      }

    }
  }
}
</style>
